import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TProject } from '../../../../models/projects/project.model';
import { TApiResponse } from '../../api.interfaces';
import { allowStatus400 } from '../../decorators';

@Injectable()
export class ProjectsApi {
  constructor(private readonly httpClient: HttpClient) {}

  async getAllProjects() {
    const projects = await this.httpClient.get('projects').toPromise();
    return projects as TProject[];
  }

  async createProject(formData: { name: string; description: string }) {
    const result = await this.httpClient
      .post('projects/create', formData)
      .toPromise();
    return result;
  }

  async getProject(projectAlias: string) {
    const result = (await this.httpClient
      .get(`projects/project/${projectAlias}`)
      .toPromise()) as TProject | null;
    return result;
  }

  @allowStatus400()
  async renameProject(projectAlias: string, newName: string) {
    const result = (await this.httpClient
      .post(`projects/project/${projectAlias}/rename`, { newName })
      .toPromise()) as TApiResponse<{ project: TProject }>;
    return result;
  }

  @allowStatus400()
  async editProjectDescription(projectAlias: string, newDescription: string) {
    const result = (await this.httpClient
      .post(`projects/project/${projectAlias}/edit/description`, {
        newDescription,
      })
      .toPromise()) as TApiResponse<{ project: TProject }>;
    return result;
  }
}
